import CaretWrapper from './CaretWrapper.jsx';

export default CaretWrapper;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/PanelFilterGroupCollection/CaretWrapper/index.js